// ./web3modalConfig.js
import { createConfig, http } from 'wagmi';
import { metis } from 'wagmi/chains';
import { injected } from 'wagmi/connectors';

export const wagmiConfig = createConfig({
  chains: [metis],
  connectors: [injected()],
  transports: {
    [metis.id]: http("https://andromeda.metis.io/?owner=1088"),
  },
});
